import {
    usePortfolioSelectedSymbol,
    usePortfolioSelectionSymbology,
} from 'portfolio/store/hooks';
import { useAppSelector, useDispatch } from 'store/hooks';
import {
    DarkVenueHeatmapRequest,
    toUid,
} from 'widgets/darkVenueHeatmap/store/data/DarkVenueHeatmapRequest.ts';
import {
    clearData,
    selectDarkVenueHeatmapState,
} from 'widgets/darkVenueHeatmap/store/data/dataSlice.ts';
import { DarkVenueHeatmapSymbolDataState } from 'widgets/darkVenueHeatmap/store/data/DarkVenueHeatmapDataState.ts';
import {
    useCheckWidgetStream,
    useClearResponse,
} from 'widgets/streaming/hooks.ts';
import { useCallback } from 'react';
import { useLogger } from 'logging/writers/hooks.ts';

export function useDarkVenueHeatMapDataRequestUid() {
    const symbol = usePortfolioSelectedSymbol();
    const symbology = usePortfolioSelectionSymbology();

    if (!symbol) {
        return undefined;
    }

    const request: DarkVenueHeatmapRequest = { symbol, symbology };
    return request ? toUid(request) : undefined;
}

export function useDarkVenueHeatMapData():
    | DarkVenueHeatmapSymbolDataState
    | undefined {
    const uid = useDarkVenueHeatMapDataRequestUid();
    return useAppSelector((s) => selectDarkVenueHeatmapState(s, uid ?? ''));
}

export function useReRunDarkVenueHeatMapRequest() {
    const uid = useDarkVenueHeatMapDataRequestUid();
    const clearRestResponse = useClearResponse(uid);
    const dispatcher = useDispatch();
    const checkWidgetStream = useCheckWidgetStream();
    const logger = useLogger('useReRunDarkVenueHeatMapRequest');

    return useCallback(() => {
        if (uid) {
            logger.debug('Re-running query for ' + uid);
            clearRestResponse();
            dispatcher(clearData(uid));
            setTimeout(() => {
                checkWidgetStream();
            }, 0);
        }
    }, [clearRestResponse, checkWidgetStream, dispatcher, logger, uid]);
}
